
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SketchBookEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(40 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.4 / (layerIndex + 1);
            for (let i = 0; i < lines; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const length = (100 + this.pseudoRandom(i + 2) * 200) * scale;
                
                // Hand-drawn line shimmy
                ctx.beginPath();
                ctx.moveTo(rx, ry);
                for (let j = 0; j < 5; j++) {
                    const tx = rx + (j/5) * length;
                    const ty = ry + Math.sin(j + time * 2) * 2 * scale;
                    ctx.lineTo(tx, ty);
                }
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
